import React, { useState } from "react";
import { api, errMsg } from "../lib/api";
import { toast } from "sonner";
import { X } from "lucide-react";

export default function DepositNoteModal({ table, onClose }) {
  const [form, setForm] = useState({ people: 1, table_label: table.name, note: "", accept: false });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!form.note.trim()) { toast.error("La nota è obbligatoria"); return; }
    if (!form.accept) { toast.error("Devi accettare che la caparra non è rimborsabile"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout/session", {
        table_id: table.id, people: Number(form.people),
        table_label: form.table_label, note: form.note,
      });
      window.location.href = data.url;
    } catch (err) {
      toast.error(errMsg(err, "Errore checkout"));
      setLoading(false);
    }
  };
  return (
    <div className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-md flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-neutral-950 border border-neutral-800 w-full max-w-md p-8 relative" onClick={e=>e.stopPropagation()} data-testid="deposit-note-modal">
        <button className="absolute top-4 right-4 text-neutral-500 hover:text-white" onClick={onClose} data-testid="deposit-note-close" aria-label="Chiudi"><X/></button>
        <div className="label-mono text-neon mb-2">PAGA CAPARRA</div>
        <h3 className="font-display text-2xl mb-1">€{table.deposit_per_person}</h3>
        <div className="font-mono text-xs text-neutral-500 tracking-widest mb-2">{table.event_title} · {table.venue}</div>
        {table.price_per_person != null && (
          <p className="text-xs text-neutral-400 mb-6" data-testid="deposit-price-info">
            {table.table_price != null && <>Ingresso €{table.entry_price} + tavolo €{table.table_price}. </>}
            Totale: €{table.price_per_person} a persona. Ora paghi solo la caparra di €{table.deposit_per_person}; il resto si salda al locale.
          </p>
        )}
        <form onSubmit={submit} className="space-y-5">
          <div className="grid grid-cols-[100px_1fr] gap-4">
            <div>
              <div className="label-mono mb-1">PERSONE</div>
              <input required type="number" min="1" max="20" value={form.people} onChange={e=>setForm({...form,people:e.target.value})} className="input-dark" data-testid="deposit-people"/>
            </div>
            <div>
              <div className="label-mono mb-1">NOME TAVOLO</div>
              <input required maxLength={60} value={form.table_label} onChange={e=>setForm({...form,table_label:e.target.value})} className="input-dark" data-testid="deposit-table-label"/>
            </div>
          </div>
          <div>
            <div className="label-mono mb-1">NOTA PER IL PR (obbligatoria)</div>
            <textarea required rows={3} maxLength={300} value={form.note} onChange={e=>setForm({...form,note:e.target.value})}
              placeholder="Es. nome del tavolo, quanti siete"
              className="input-dark resize-none" data-testid="deposit-note"/>
          </div>
          <label className="flex items-start gap-3 text-xs text-neutral-300 cursor-pointer">
            <input type="checkbox" checked={form.accept} onChange={e=>setForm({...form,accept:e.target.checked})} className="accent-[#00FF66] mt-0.5" data-testid="deposit-accept"/>
            <span>Ho capito che <span className="text-alert">in caso di recesso dal tavolo la caparra non è rimborsabile</span>.</span>
          </label>
          <button disabled={loading} className="btn-primary w-full" data-testid="deposit-submit">{loading ? "..." : "VAI AL PAGAMENTO"}</button>
        </form>
      </div>
    </div>
  );
}
